import type { IRateCalculatorIconVariant } from 'BreetAssets';
import type { ISellAssets } from 'BreetHelpers';
import type { Dispatch, ReactNode, SetStateAction } from 'react';
import * as yup from 'yup';

export type RATECALCULATORTYPE = 'rate-calculator' | 'asset-details';

export const rateCalculatorStageTitle: Record<RATECALCULATORTYPE, string> = {
	'rate-calculator': 'Rate Calculator',
	'asset-details': 'Address Details',
};

export const tabs = ['Wallet Address', 'USD Wallet'] as const;

export type TABTYPE = (typeof tabs)[number];

export interface IRateCalculatorContext {
	selectedAsset?: ISellAssets;
	setSelectedAsset: Dispatch<SetStateAction<ISellAssets | undefined>>;
}

export const RateCalculatorSellCryptoSchema = yup.object({
	currencyAmount: yup.string(),
	cryptoAmount: yup.string(),
});

export type RateCalculatorSellCryptoSchemaType = yup.InferType<typeof RateCalculatorSellCryptoSchema>;

export interface IExchangeInfoItemProps {
	variant: IRateCalculatorIconVariant;
	label: string;
	value?: string;
	children?: ReactNode;
}
